import { useContext } from "react";
import UserContext from "src/contexts/UserContext";
import Logo from "./Logo";
import Navbar from "./Navbar";
const debug = require("debug")("app:LogoNavbar");

interface LogoNavbarProps {}

export default function LogoNavbar(props: LogoNavbarProps) {
  const { user } = useContext(UserContext);
  const url =
    user?.type === "admin"
      ? "/admin"
      : user?.type === "student"
      ? "/dashboard"
      : "/login";

  return <Navbar left={<Logo urlOnClick={url} showName={false} />} />;
}
